var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.13 7.15014C19.17 7.76014 19.12 8.45014 19 9.22014L18.27 13.9101C17.65 17.8201 15.84 19.1401 11.93 18.5301L7.23999 17.7901C5.88999 17.5801 4.84999 17.2201 4.08999 16.6801C2.63999 15.6701 2.21999 14.0101 2.61999 11.4501L3.35999 6.76014C3.97999 2.85014 5.78999 1.53014 9.69999 2.14014L14.39 2.88014C17.53 3.37014 19 4.65014 19.13 7.15014Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 13.4699L19.4998 17.9799C18.2498 21.7399 16.2498 22.7399 12.4898 21.4899L7.97984 19.9899C5.70984 19.2399 4.44984 18.1999 4.08984 16.6799C4.84984 17.2199 5.88984 17.5799 7.23984 17.7899L11.9298 18.5299C15.8398 19.1399 17.6498 17.8199 18.2698 13.9099L18.9998 9.2199C19.1198 8.4499 19.1698 7.7599 19.1298 7.1499C21.5198 8.4199 22.0398 10.3399 20.9998 13.4699Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74 8.98C9.70098 8.98 10.48 8.20098 10.48 7.24C10.48 6.27902 9.70098 5.5 8.74 5.5C7.77902 5.5 7 6.27902 7 7.24C7 8.20098 7.77902 8.98 8.74 8.98Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.6036c0df3648aeaaba35fee9a71aef81.svg";
export { ForwardRef as ReactComponent };